module.exports = __webpack_public_path__ + "static/media/Jumping_Jacks.a1d4121e.gif";